'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
var $p;
/** @constructor */
function $c_Lpresto_types$proto$SitesByCredential(hash, kind) {
  this.ZW = null;
  this.ZX = null;
  this.ZW = hash;
  this.ZX = kind;
}
export { $c_Lpresto_types$proto$SitesByCredential as $c_Lpresto_types$proto$SitesByCredential };
$p = $c_Lpresto_types$proto$SitesByCredential.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$proto$SitesByCredential;
/** @constructor */
function $h_Lpresto_types$proto$SitesByCredential() {
}
export { $h_Lpresto_types$proto$SitesByCredential as $h_Lpresto_types$proto$SitesByCredential };
$h_Lpresto_types$proto$SitesByCredential.prototype = $p;
$p.x = (function() {
  return new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_s_Product$$anon$1(this);
});
$p.p = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_util_hashing_MurmurHash3$().S(this, (-889275714), false);
});
$p.i = (function(x$0) {
  if ((this === x$0)) {
    return true;
  } else if ((x$0 instanceof $c_Lpresto_types$proto$SitesByCredential)) {
    if ((this.ZW === x$0.ZW)) {
      var x = this.ZX;
      var x$2 = x$0.ZX;
      return (x === x$2);
    } else {
      return false;
    }
  } else {
    return false;
  }
});
$p.l = (function() {
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_sr_ScalaRunTime$().H(this);
});
$p.r = (function() {
  return 2;
});
$p.s = (function() {
  return "SitesByCredential";
});
$p.j = (function(n) {
  if ((n === 0)) {
    return this.ZW;
  }
  if ((n === 1)) {
    return this.ZX;
  }
  throw $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
function $isArrayOf_Lpresto_types$proto$SitesByCredential(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.lQ)));
}
export { $isArrayOf_Lpresto_types$proto$SitesByCredential as $isArrayOf_Lpresto_types$proto$SitesByCredential };
var $d_Lpresto_types$proto$SitesByCredential = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$proto$SitesByCredential, "presto.types$proto$SitesByCredential", ({
  lQ: 1,
  ef: 1,
  b: 1,
  c: 1,
  a: 1
}));
export { $d_Lpresto_types$proto$SitesByCredential as $d_Lpresto_types$proto$SitesByCredential };
//# sourceMappingURL=presto.types$proto$-Sites-By-Credential.js.map
